import { configureStore } from '@reduxjs/toolkit';

import { actionBarMiddleware } from './action-bar/actionBarMiddleware';
import { cellSelectionsNoOpMiddleware } from './cellSelections/noOpMiddleware';
import { presenceMiddleware } from './presence/presenceMiddleware';
import { defaultReducers, getAppStoreUtils } from './redux';
import { type AppRootState } from './types';

export const appStore = configureStore({
  reducer: {
    ...defaultReducers
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    }).concat(
      presenceMiddleware.middleware,
      actionBarMiddleware.middleware,
      cellSelectionsNoOpMiddleware
    )
});

export type { AppRootState } from './types';
export const appStoreUtils = getAppStoreUtils<AppRootState>();
